import FrontGradientMaterial from '../materials/FrontGradientMaterial';
import { REF_SIZE, REF_SIZE_PT, UNIT } from '../../../constants/size';
import { formatGradient } from '../../../utils/gradient';

const THREE = require('three');

class GradientDissolveRect extends THREE.Mesh {
    constructor(gradient, fog = true) {
        let size = Math.max(REF_SIZE.w, REF_SIZE_PT.w, REF_SIZE.h, REF_SIZE_PT.h);

        size *= UNIT.sizesScaleRatio;

        const geometry = new THREE.PlaneBufferGeometry(size, size);

        const params = { ...formatGradient(gradient), transparent: true };
        const material = new FrontGradientMaterial(params);

        material.fog = fog;

        super(geometry, material);

        this.params = params;
        this._material = material;
    }

    set viewportWidth(value) {
        this._material.viewportWidth = value;
    }

    get viewportWidth() {
        return this._material.viewportWidth;
    }

    set viewportHeight(value) {
        this._material.viewportHeight = value;
    }

    get viewportHeight() {
        return this._material.viewportHeight;
    }

    set opacity(value) {
        this._material.opacity = value;
        this.visible = value > 0;
    }

    get opacity() {
        return this._material.opacity;
    }

    setGradient(value) {
        if (!this._material) return;
        this._material.setGradientUniforms(formatGradient(value));
    }
}

export default GradientDissolveRect;
